import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{staticClass:"navbar-bg",staticStyle:{"margin-top":"5rem"},attrs:{"padless":"","elevation":"5"}},[_c(VCard,{staticClass:"text-center",staticStyle:{"background-color":"transparent"},attrs:{"flat":"","tile":"","width":"100%"}},[_c(VDivider),_c(VCardText,[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" — Anand Kumar ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }